(function() {
    'use strict';

    angular.module('product')
        .controller('ProductUpdateController', ProductUpdateController);

    ProductUpdateController.$inject = ['$state', '$timeout', 'productDataSrvc', 'productSrvc', 'notificationSrvc', 'productMessagesConst', 'categoryDataSrvc', 'productCountryConst', 'appliancesDataSrvc', 'productParameterDataSrvc', 'packageDataSrvc', 'formatGroupDataSrvc', 'formatDataSrvc', 'fileDataSrvc', 'productQuantityDataSrvc', 'productQuantitySrvc', 'lodashService', 'productQuantityMessagesConst', 'pageDataSrvc', 'productOptionGroupDataSrvc', 'productOptionDataSrvc', '$uibModal', 'productGalleryDataSrvc', 'productGalleryMessagesConst', 'productgalleryPermissionsConst', 'productoptionpricePermissionsConst', 'checkModelPermissionsSrvc', 'productQuantityPermissionsConst', 'productOptionGroupPermissionsConst', 'productOptionPermissionsConst', 'errorNotificationSrvc'];

    function ProductUpdateController($state, $timeout, productDataSrvc, productSrvc, notificationSrvc, productMessagesConst, categoryDataSrvc, productCountryConst, appliancesDataSrvc, productParameterDataSrvc, packageDataSrvc, formatGroupDataSrvc, formatDataSrvc, fileDataSrvc, productQuantityDataSrvc, productQuantitySrvc, lodashService, productQuantityMessagesConst, pageDataSrvc, productOptionGroupDataSrvc, productOptionDataSrvc, $uibModal, productGalleryDataSrvc, productGalleryMessagesConst, productgalleryPermissionsConst, productoptionpricePermissionsConst, checkModelPermissionsSrvc, productQuantityPermissionsConst, productOptionGroupPermissionsConst, productOptionPermissionsConst, errorNotificationSrvc) {
        var self = this;

        self.quantitiesLoading = true;
        self.optionGroupLoading = true;
        self.exportPricesLoading = false;

        self.serverErrors = {
            name_pl: [],
            name_en: [],
            name_de: [],
            name_cpde: [],
            name_cpen: [],
            short_description_pl: [],
            short_description_en: [],
            short_description_de: [],
            short_description_cpde: [],
            short_description_cpen: [],
            description_pl: [],
            description_en: [],
            description_de: [],
            description_cpde: [],
            description_cpen: [],
            title_seo_pl: [],
            title_seo_de: [],
            title_seo_en: [],
            title_seo_cpde: [],
            title_seo_cpen: [],
            description_seo_pl: [],
            description_seo_de: [],
            description_seo_en: [],
            description_seo_cpde: [],
            description_seo_cpen: [],
            keywords_seo_pl: [],
            keywords_seo_de: [],
            keywords_seo_en: [],
            keywords_seo_cpde: [],
            keywords_seo_cpen: [],
            categories: [],
            appliances: [],
            parameters: [],
            group_options: [],
            options: [],
            package: [],
            horizontal: [],
            is_published: [],
            is_popular: [],
            date_from: [],
            date_to: [],
            deadline: [],
            bleed: [],
            text_margin: [],
            frozen_price: [],
            imposition: [],
            exclusive_sheet: [],
            from_warehouse: [],
            unit_weight: [],
            image: [],
            gallery: [],
            available_in_countries: [],
            materials_pl: [],
            materials_en: [],
            materials_de: [],
            materials_cpde: [],
            materials_cpen: [],
            nonFieldErrors: [],
            page: [],
            kind: [],
            option_group_for_page_count: [],
            option_group_for_cover_page_count: [],
            deadline_time: [],
            is_available_on_allegro: []
        };
        self.productData = {};
        self.countryList = productCountryConst;
        self.categoriesList = [];
        self.appliancesList = [];
        self.productParametersList = [];
        self.productGroupOptionsList = [];
        self.packagesList = [];
        self.formatsList = [];
        self.materialsFilesList = [];
        self.pagesList = [];
        self.optionsList = [];
        self.kindOptions = [];
        self.groupOptionsForPageNum = [];

        self.extraActions = [{
            class: 'btn btn-success btn-xs',
            iconClass: 'fa fa-cog',
            onClick: onOptionPricesInQuantityDisplay,
            title: 'Ceny opcji w nakładach'
        }];

        // ngModel for duallist options
        self.selectedParametersPks = [];
        self.selectedGroupOptionsPks = [];

        // ngModel for duallist subOptions
        self.selectedParametersOptionsPks = [];

        self.updateProduct = updateProduct;
        self.cleanErrors = cleanErrors;

        self.quantityModelPermissions = productQuantityPermissionsConst;
        self.hasQuantityViewPermission = hasQuantityViewPermission;
        self.onQuantityEdit = onQuantityEdit;
        self.onQuantityDelete = onQuantityDelete;

        self.quantityRows = [];
        self.quantityCols = [{
            title: 'Nakład',
            value: 'quantity',
            type: 'number',
            required: true,
            isEditable: true
        }, {
            title: 'Nakład widoczny',
            value: 'display_quantity',
            type: 'number',
            required: true,
            isEditable: true
        }, {
            title: 'Cena',
            value: 'price',
            type: 'number',
            required: true,
            isEditable: true
        }, {
            title: 'Dni realizacji',
            value: 'realization_days',
            type: 'number',
            required: false,
            minValue: 0,
            isEditable: true
        }];

        self.productGroupOptionsCols = [{
            title: 'ID',
            value: 'group_option',
            type: 'text'
        }, {
            title: 'Nazwa',
            value: 'group_option_name',
            type: 'text'
        }];
        self.productGroupSubOptionsCols = [{
            title: 'ID',
            value: 'option',
            type: 'text'
        }, {
            title: 'Nazwa',
            value: 'option_name',
            type: 'text'
        }];

        self.hasProductOptionGroupViewPermission = hasProductOptionGroupViewPermission;
        self.productOptionGroupModelPermissions = productOptionGroupPermissionsConst;
        self.productOptionPermissions = productOptionPermissionsConst;

        self.onOptionsGroupAdd = onOptionsGroupAdd;
        self.onOptionsGroupRemove = onOptionsGroupRemove;
        self.onOptionsGroupReorder = onOptionsGroupReorder;
        self.onOptionsGroupOptionsAdd = onOptionsGroupOptionsAdd;
        self.onOptionsGroupOptionsRemove = onOptionsGroupOptionsRemove;
        self.onOptionsGroupOptionsReorder = onOptionsGroupOptionsReorder;

        self.onOptionPricesByQuantityDisplay = onOptionPricesByQuantityDisplay;
        self.onOptionPricesInQuantityDisplay = onOptionPricesInQuantityDisplay;

        self.galleryModelPermissions = productgalleryPermissionsConst;
        self.galleryDefaultMessage = productGalleryMessagesConst.defaultMessage;
        self.galleryImageCreate = galleryImageCreate;
        self.galleryImageDelete = galleryImageDelete;

        self.onFilesSearch = onFilesSearch;
        self.onProductOptionsChange = onProductOptionsChange;

        self.exportProductPrices = exportProductPrices;
        self.importProductPrices = importProductPrices;

        self.applyProductLog = applyProductLog;

        activate();

        function activate() {
            getProduct();
            getCategories();
            getAppliances();
            getProductParameters();
            getGroupOptions();
            getPackages();
            getFormats();
            getFiles();
            getPages();
            getOptions();
            getKindOptions();
        }

        function getProduct() {
            self.quantitiesLoading = true;
            self.optionGroupLoading = true;

            return productDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(function(response) {
                self.productData = response;
                self.quantityRows = response.quantities || [];
                self.selectedParametersPks = [];
                self.selectedParametersOptionsPks = [];
                self.selectedGroupOptionsPks = [];

                // Build ngModel(s) for duallist options and subOptions
                var i;
                for (i = 0; i < self.productData.parameters.length; ++i) {
                    self.selectedParametersPks.push(self.productData.parameters[i].parameter);

                    self.selectedParametersOptionsPks.push({
                        parameter: self.productData.parameters[i].parameter,
                        parameter_options: self.productData.parameters[i].parameter_options
                    });
                }
                for (i = 0; i < self.productData.group_options.length; ++i) {
                    self.selectedGroupOptionsPks.push(self.productData.group_options[i].group_option);
                }

                self.groupOptionsForPageNum = getGroupOptionsForPageNum();

                return response;
            }).finally(function(response) {
                self.quantitiesLoading = false;
                self.optionGroupLoading = false;
                return response;
            });
        }

        function getCategories() {
            return categoryDataSrvc.productParents()
                .$promise.then(function(response) {
                    self.categoriesList = response;
                    return response;
                });
        }

        function getAppliances() {
            return appliancesDataSrvc.productAppliances()
                .$promise.then(function(response) {
                    self.appliancesList = response;
                    return response;
                });
        }

        function getProductParameters() {
            return productParameterDataSrvc.productParameters()
                .$promise.then(function(response) {
                    self.productParametersList = response;
                    return response;
                });
        }

        function getGroupOptions() {
            return productOptionGroupDataSrvc.productGroupOptions()
                .$promise.then(function(response) {
                    self.productGroupOptionsList = response;
                    self.groupOptionsForPageNum = getGroupOptionsForPageNum();
                    return response;
                });
        }

        function getPackages() {
            return packageDataSrvc.packageOptions()
                .$promise.then(function(response) {
                    self.packagesList = response;
                    return response;
                });
        }

        function getFormats() {
            return formatDataSrvc.formatsAsOptions()
                .$promise.then(function(response) {
                    self.formatsList = response;
                    for (var i = response.length - 1; i >= 0; i--) {
                        self.formatsList[i].name = self.formatsList[i].size_x + ' x ' + self.formatsList[i].size_y;
                    }

                    return response;
                });
        }

        function getFiles() {
            return fileDataSrvc.productMaterialsFiles({
                product_pk: $state.params.pk
            }).$promise.then(function(response) {
                self.materialsFilesList = response.results;
                return response;
            });
        }

        function onFilesSearch(params) {
            if (!params) {
                params = {};
            }
            params.product_pk = $state.params.pk;
            return fileDataSrvc.productMaterialsFiles(
                params
            ).$promise;
        }

        function getPages() {
            return pageDataSrvc.productPages()
                .$promise.then(function(response) {
                    self.pagesList = response;
                    return response;
                });
        }

        function getOptions() {
            return productOptionDataSrvc.productOptions()
                .$promise.then(function(response) {
                    self.optionsList = response;
                    self.groupOptionsForPageNum = getGroupOptionsForPageNum();
                    return response;
                });
        }

        function getKindOptions() {
            return productDataSrvc.kindOptions()
                .$promise.then(function (response) {
                    self.kindOptions = response;
                });
        }

        function updateProduct() {
            self.productData.parameters = self.selectedParametersOptionsPks;

            return productDataSrvc.update({
                pk: self.productData.pk
            }, self.productData).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", productMessagesConst.update);
                    $state.go('layout.product.list');
                    return response;
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }

        function hasQuantityViewPermission() {
            return !checkModelPermissionsSrvc.isDenied(
                productQuantityPermissionsConst.view);
        }

        function onQuantityEdit(row, isNewRow) {
            row.product = self.productData.pk;
            if (isNewRow) {
                delete row.pk;
                return productQuantityDataSrvc.create(row);
            } else {
                return productQuantityDataSrvc.update({
                    pk: row.pk
                }, row);
            }
        }

        function onQuantityDelete(row) {
            return productQuantitySrvc.remove("ten nakład", row.pk,
                function(response) {
                    removeQuantityRow(row);
                    return response;
                },
                function(error) {
                    if (error.status === 404) {
                        removeQuantityRow(row);
                    }
                });
        }

        function removeQuantityRow(row) {
            notificationSrvc.notification("success", productQuantityMessagesConst.delete);
            lodashService.remove(self.quantityRows, { pk: row.pk });
        }

        function hasOptionPricesViewPermission() {
            return !checkModelPermissionsSrvc.isDenied(
                productoptionpricePermissionsConst.view);
        }

        function onOptionPricesByQuantityDisplay(option) {
            if (!hasOptionPricesViewPermission()) {
                notificationSrvc.notification("error", productoptionpricePermissionsConst.view.errorMsg);
                return;
            }

            $uibModal.open({
                templateUrl: 'app/product/views/product-option-prices-by-quantity-update/product-option-prices-by-quantity-update.html',
                controller: 'ProductOptionPricesByQuantityUpdate',
                controllerAs: 'ctrl',
                size: 'lg',
                resolve: {
                    currentOption: function() {
                        return option;
                    },
                    product: function() {
                        return self.productData;
                    }
                }
            }).result.then(
                function(result) {
                    return result;
                }
            );
        }

        function onOptionPricesInQuantityDisplay(quantity) {
            if (!hasOptionPricesViewPermission()) {
                notificationSrvc.notification("error", productoptionpricePermissionsConst.view.errorMsg);
                return;
            }

            $uibModal.open({
                templateUrl: 'app/product/views/product-option-prices-in-quantity-update/product-option-prices-in-quantity-update.html',
                controller: 'ProductOptionPricesInQuantityUpdate',
                controllerAs: 'ctrl',
                size: 'lg',
                resolve: {
                    currentQuantity: function() {
                        return quantity;
                    },
                    product: function() {
                        return self.productData;
                    },
                    options: function() {
                        return self.optionsList;
                    }
                }
            }).result.then(
                function(result) {
                    return result;
                }
            );
        }

        function galleryImageCreate(imageFileObject, successCallback) {
            productGalleryDataSrvc.create({
                image: imageFileObject,
                product: self.productData.pk
            }).$promise.then(function(response) {
                successCallback(response.pk);
                notificationSrvc.notification("success", productGalleryMessagesConst.add);
                return response;
            }, function(response) {
                errorNotificationSrvc.displayErrors(response.data);
            });
        }

        function galleryImageDelete(image_pk) {
            productGalleryDataSrvc.delete({
                pk: image_pk
            }).$promise.then(function(response) {
                notificationSrvc.notification("success", productGalleryMessagesConst.delete);
                return response;
            }, function(response) {
                errorNotificationSrvc.displayErrors(response.data);
            });
        }

        function hasProductOptionGroupViewPermission() {
            return !checkModelPermissionsSrvc.isDenied(
                productOptionGroupPermissionsConst.view);
        }

        function onOptionsGroupAdd() {
            $uibModal.open({
                templateUrl: 'app/product/views/product-options-group-add-modal/product-options-group-add-modal.html',
                controller: 'ProductOptionsGroupAddModalController',
                controllerAs: 'ctrl',
                size: 'lg',
                resolve: {
                    product: function() {
                        return self.productData;
                    },
                    optionsGroups: function() {
                        return lodashService.differenceWith(
                            self.productGroupOptionsList,
                            self.productData.group_options,
                            function(group, assignedGroup) {
                                return group.pk === assignedGroup.group_option;
                            }
                        );
                    }
                }
            }).result.then(
                function(results) {
                    angular.forEach(results, function(group) {
                        self.productData.group_options.push({
                            group_option: group.pk,
                            group_option_name: group.name,
                            options: []
                        });
                    });
                    self.groupOptionsForPageNum = getGroupOptionsForPageNum();
                    return results;
                }
            );
        }

        function onOptionsGroupRemove(row) {
            lodashService.remove(self.productData.group_options, function(group) {
                return group.group_option === row.group_option;
            });
            self.groupOptionsForPageNum = getGroupOptionsForPageNum();
        }

        function onOptionsGroupReorder(row, newPos) {
            var index = 1;
            angular.forEach(self.productData.group_options, function(group) {
                group.position = index;
                index++;
            });
        }

        function onOptionsGroupOptionsAdd(row) {
            $uibModal.open({
                templateUrl: 'app/product/views/product-options-group-options-add-modal/product-options-group-options-add-modal.html',
                controller: 'ProductOptionsGroupOptionsAddModalController',
                controllerAs: 'ctrl',
                size: 'lg',
                resolve: {
                    group_option: function() {
                        return row;
                    },
                    options: function() {
                        var group = lodashService.find(self.productGroupOptionsList, function(grp) {
                            return grp.pk === row.group_option;
                        });

                        if (group) {
                            return lodashService.differenceWith(
                                group.product_options,
                                row.options,
                                function(option, assignedOption) {
                                    return option.pk === assignedOption.option;
                                }
                            );
                        } else {
                            return [];
                        }
                    }
                }
            }).result.then(
                function(results) {
                    angular.forEach(results.options, function(option) {
                        results.group_option.options.push({
                            option: option.pk,
                            option_name: option.label,
                            position: results.group_option.options.length
                        });
                    });
                    return results;
                }
            );
        }

        function onOptionsGroupOptionsRemove(group, row) {
            lodashService.remove(group.options, function(option) {
                return option.option === row.option;
            });
        }

        function onOptionsGroupOptionsReorder(parent, row, newPos) {
            var index = 1;
            angular.forEach(parent.options, function(option) {
                option.position = index;
                index++;
            });
        }

        function getGroupOptionsForPageNum() {
            var selectedGroups = lodashService.flatMap(self.productData.group_options || [], 'group_option'),
                selectedOptionsGroups = lodashService.map(self.productData.options || [], function (option_pk) {
                    var option = lodashService.find(self.optionsList || [], { 'pk': option_pk });
                    if (option) {
                        return option.options_group
                    }
                }),
                allowedGroupsIds = lodashService.concat(selectedGroups, selectedOptionsGroups),
                allowedGroups = lodashService.sortBy(lodashService.filter(self.productGroupOptionsList || [], function (group) {
                    return lodashService.includes(allowedGroupsIds, group.pk);
                }), 'pk');
            return allowedGroups;
        }

        function onProductOptionsChange() {
            $timeout(function () {
                self.groupOptionsForPageNum = getGroupOptionsForPageNum();
            });
        }

        function exportProductPrices() {
            if (!self.exportPricesLoading) {
                self.exportPricesLoading = true;
                productSrvc.exportProductPrices(self.productData.pk).then(
                    function () {
                        self.exportPricesLoading = false;
                    },
                    function () {
                        self.exportPricesLoading = false;
                    }
                );
            }
        }

        function importProductPrices() {
            $uibModal.open({
                templateUrl: 'app/product/views/product-import-prices-modal/product-import-prices-modal.html',
                controller: 'ProductImportPricesModalController',
                controllerAs: 'ctrl',
                size: 'lg',
                resolve: {
                    product: function() {
                        return self.productData;
                    }
                }
            }).result.then(
                function (results) {
                    getProduct();
                    return results;
                }
            );
        }

        function applyProductLog() {
            $uibModal.open({
                templateUrl: 'app/product/views/product-log-apply-modal/product-log-apply-modal.html',
                controller: 'ProductLogApplyModalController',
                controllerAs: 'ctrl',
                size: 'lg',
                resolve: {
                    product: function() {
                        return self.productData;
                    }
                }
            }).result.then(
                function (results) {
                    getProduct();
                    return results;
                }
            );
        }
    }
})();
